import React from 'react';
import { motion } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
export function HeroSection() {
  return <section className="relative z-10 flex flex-col items-center justify-center min-h-screen px-6 py-20 text-center" data-id="element-56">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.8
    }} className="flex flex-col items-center max-w-3xl mx-auto" data-id="element-57">
        <div className="inline-flex items-center px-4 py-1.5 mb-8 text-sm font-bold tracking-wide text-gold uppercase rounded-full bg-white/5 border border-gold/20 backdrop-blur-sm" data-id="element-58">
          Small Bright Star ⭐
        </div>

        <div className="relative mb-10 animate-float" data-id="element-59">
          <div className="absolute inset-0 rounded-full bg-gold/20 blur-3xl animate-pulse" data-id="element-60"></div>
          <img src="https://cdn.magicpatterns.com/uploads/au7Si8211VzNDA16LvWE5k/heylloyd-image-1774147042087.png" alt="Estrella durmiendo feliz" className="relative z-10 w-[280px] md:w-[350px] h-auto drop-shadow-[0_0_30px_rgba(245,197,66,0.3)]" data-id="element-61" />
        </div>

        <h1 className="mb-6 text-4xl font-bold leading-tight md:text-5xl lg:text-6xl font-heading text-gold drop-shadow-lg" data-id="element-62">
          ¿Tu peque sabe lo mucho que brilla? ⭐
        </h1>

        <p className="max-w-2xl text-xl leading-relaxed md:text-2xl font-body text-warmWhite drop-shadow-md" data-id="element-63">
          Ayúdale a construir una autoestima inquebrantable en solo 10 minutos
          al día.
        </p>

        <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        delay: 1,
        duration: 1
      }} className="mt-16 text-mutedPurple animate-bounce" data-id="element-64">
          <ChevronDown size={32} data-id="element-65" />
        </motion.div>
      </motion.div>
    </section>;
}